// Extending the String prototype

interface String {
  lastSplitValue(separator?: string): string;
}

String.prototype.lastSplitValue = function (separator: string = '/'): string {
  if (this && this.length) return this.split(separator).reverse()[0];
  return '';
};
